import React from 'react';
import { 
  MapPinIcon,
  CloudIcon,
  PhoneIcon,
  ScaleIcon
} from '@heroicons/react/24/outline';

const MaltaTrustStrip = () => {
  const trustPoints = [
    {
      icon: MapPinIcon,
      title: "Built for Malta",
      description: "Designed specifically for Maltese payroll regulations"
    },
    {
      icon: CloudIcon,
      title: "Cloud-Based",
      description: "Access from anywhere, anytime"
    },
    {
      icon: PhoneIcon,
      title: "Local Support",
      description: "Malta-based customer support team"
    },
    {
      icon: ScaleIcon,
      title: "Scales 5-5,000",
      description: "From small businesses to large enterprises"
    }
  ];

  return (
    <div className="bg-gray-50 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {trustPoints.map((point, index) => (
            <div key={index} className="text-center">
              <div className="flex items-center justify-center h-12 w-12 rounded-md bg-orange-100 text-orange-600 mx-auto">
                <point.icon className="h-6 w-6" aria-hidden="true" />
              </div>
              <h3 className="mt-4 text-lg font-medium text-gray-900">
                {point.title}
              </h3>
              <p className="mt-2 text-sm text-gray-500">
                {point.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MaltaTrustStrip;

